export const RESET_CREATE_STATE = "RESET_CREATE_STATE";
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";
export const SET_FORM_DATA = "SET_FORM_DATA";
export const INCREMENT_CREATE_KEY = "INCREMENT_CREATE_KEY";
